import { DecimalPipe } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TooltipModule } from 'primeng/tooltip';
import { OrdenServicioDetalleProgramar } from 'src/app/domain/model/orden-servicio/orden-servicio';
import {
  IT_DETALLE_TEXTO_ANULAR_RECHAZO,
  IT_DETALLE_TEXTO_ESTADO_PENDIENTE_RECHAZO
} from '../../services/informacion-tareas-detalle.constants';

@Component({
  selector: 'app-resumen-detalle-orden',
  standalone: true,
  imports: [DecimalPipe, ButtonModule, CardModule, TooltipModule],
  template: `
    <p-card header="Detalle de la tarea">
      <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3 text-sm">
        <div><span class="font-semibold">Orientaci&oacute;n:</span> {{ detalle()?.codigoOrden || '-' }}</div>
        <div><span class="font-semibold">Fecha de aprobaci&oacute;n:</span> {{ formatDate(detalle()?.fechaAprobacion) }}</div>
        <div><span class="font-semibold">Clasificaci&oacute;n:</span> {{ detalle()?.clasificacion || '-' }}</div>
        <div><span class="font-semibold">Cliente:</span> {{ detalle()?.nombreBeneficiario || '-' }}</div>
        <div><span class="font-semibold">Centro de trabajo:</span> {{ detalle()?.centroTrabajo || '-' }}</div>
        <div><span class="font-semibold">Producto:</span> {{ detalle()?.producto || '-' }}</div>
        <div><span class="font-semibold">Tar&eacute;a:</span> {{ detalle()?.tareaCliente || '-' }}</div>
        <div><span class="font-semibold">Forma de entrega:</span> {{ detalle()?.formaEntrega || '-' }}</div>
        <div><span class="font-semibold">Requiere informe:</span> {{ formatearSiNo(detalle()?.requiereInforme) }}</div>
        <div><span class="font-semibold">Tiene prioridad:</span> {{ formatearSiNo(detalle()?.prioridad) }}</div>
        <div><span class="font-semibold">Numero total de llamadas:</span> {{ detalle()?.numLlamadas ?? 0 }}</div>
        <div><span class="font-semibold">Valor Transporte:</span> {{ detalle()?.valorTransporte ?? 0 | number:'1.0-2' }}</div>
        <div><span class="font-semibold">Tiene transporte adicional:</span> {{ formatearSiNo(detalle()?.transporteAdicional) }}</div>
        <div><span class="font-semibold">Valor Transporte adicional:</span> {{ detalle()?.valorTransporteAdicional ?? 0 | number:'1.0-2' }}</div>
        <div><span class="font-semibold">Tiene viaticos:</span> {{ formatearSiNo(detalle()?.viaticos) }}</div>
        <div><span class="font-semibold">Valor viaticos:</span> {{ detalle()?.valorViaticos ?? 0 | number:'1.0-2' }}</div>
        <div><span class="font-semibold">Estado Tarea:</span> {{ detalle()?.estado || '-' }}</div>
        <div><span class="font-semibold">Cantidad pedida:</span> {{ detalle()?.cantidadPedida ?? 0 | number:'1.0-2' }}</div>
        <div><span class="font-semibold">Cantidad Programada:</span> {{ detalle()?.cantidadProgramada ?? 0 | number:'1.0-2' }}</div>
        <div><span class="font-semibold">Saldo por programar:</span> {{ detalle()?.saldoPorProgramar ?? 0 | number:'1.0-2' }}</div>
        <div><span class="font-semibold">Saldo por ejecutar:</span> {{ detalle()?.saldoPorEjecutar ?? 0 | number:'1.0-2' }}</div>
        <div><span class="font-semibold">UEN:</span> {{ detalle()?.cduen || detalle()?.unidadEstrategica || '-' }}</div>
        <div><span class="font-semibold">Profesional:</span> {{ detalle()?.profesional || '-' }}</div>
        <div><span class="font-semibold">Prestador:</span> {{ detalle()?.asesorSugerido || '-' }}</div>
        <div><span class="font-semibold">Contacto empresa:</span> {{ detalle()?.nombreContacto || '-' }}</div>
        <div><span class="font-semibold">Telefono:</span> {{ detalle()?.telefonoContacto || '-' }}</div>
        <div><span class="font-semibold">Municipio origen:</span> {{ detalle()?.municipioOrigen || '-' }}</div>
        <div><span class="font-semibold">Municipio destino:</span> {{ detalle()?.municipioDestino || '-' }}</div>
        <div><span class="font-semibold">Fecha entrega inicial:</span> {{ formatDate(detalle()?.fechaEntregaInicial) }}</div>
        <div><span class="font-semibold">Fecha entrega final:</span> {{ formatDate(detalle()?.fechaEntregaFinal) }}</div>
        <div class="md:col-span-2 xl:col-span-3"><span class="font-semibold">Observaciones:</span> {{ detalle()?.notas || '-' }}</div>
      </div>
    </p-card>

    @if (mostrarBloqueAnularRechazo()) {
      <p-card>
        <div class="flex items-center justify-between gap-3 flex-wrap">
          <div>
            <h3 class="text-base font-semibold text-gray-800 m-0">{{ textoAnularRechazo }}</h3>
            <p class="text-sm text-gray-500 m-0">{{ textoEstadoPendienteRechazo }}</p>
          </div>
          <button
            pButton
            type="button"
            [label]="textoAnularRechazo"
            icon="pi pi-times-circle"
            class="p-button-outlined"
            [disabled]="!habilitarAccionAnularRechazo()"
            [pTooltip]="tooltipAnularRechazo()"
            (click)="onAnularRechazoClick()">
          </button>
        </div>
      </p-card>
    }
  `
})
export class ResumenDetalleOrdenComponent {
  detalle = input<OrdenServicioDetalleProgramar | null>(null);
  mostrarBloqueAnularRechazo = input(false);
  habilitarAccionAnularRechazo = input(false);
  tooltipAnularRechazo = input('');
  anularRechazo = output<void>();

  readonly textoAnularRechazo = IT_DETALLE_TEXTO_ANULAR_RECHAZO;
  readonly textoEstadoPendienteRechazo = IT_DETALLE_TEXTO_ESTADO_PENDIENTE_RECHAZO;

  onAnularRechazoClick(): void {
    if (!this.habilitarAccionAnularRechazo()) {
      return;
    }

    this.anularRechazo.emit();
  }

  formatearSiNo(value?: string | null): string {
    if (!value) {
      return '-';
    }

    const normalized = value.trim().toUpperCase();
    if (normalized === 'S') {
      return 'Si';
    }

    if (normalized === 'N') {
      return 'No';
    }

    return value;
  }

  formatDate(dateValue?: string): string {
    if (!dateValue) {
      return '-';
    }

    const raw = dateValue.includes('T') ? dateValue.split('T')[0] : dateValue;
    const parts = raw.split('-').map((part) => Number(part));
    if (parts.length !== 3 || parts.some((part) => !Number.isFinite(part))) {
      return dateValue;
    }

    const [year, month, day] = parts;
    return `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
  }
}
